import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import EmptyState from '../components/ui/EmptyState'
import { useGrants } from './useCurrentUser'
import type { GrantCode } from './grants'

interface Props {
  /** Bu kodlardan **herhangi biri** (OR) kullanıcıda varsa {@link children} render edilir. */
  anyOf: [GrantCode, ...GrantCode[]]
  children: ReactNode
}

/**
 * Route/sayfa düzeyinde **yetki kilidi** (075). `RequireAuth` yalnız oturum kontrol eder; grant kontrolü
 * için bu sarmalayıcı kullanılır: kullanıcıda `anyOf` kodlarından hiçbiri yoksa "yetkiniz yok" ekranı,
 * varsa {@link children}. Yetkiler yüklenirken (fail-closed) hiçbir şey gösterilmez ki yetkisiz ekranı
 * yanıp sönmesin. **Asıl koruma backend'dedir** (FR-009); bu yalnız UX/erişim kilididir.
 */
export default function RequireGrant({ anyOf, children }: Readonly<Props>) {
  const { hasAnyGrant, isLoading } = useGrants()
  const { t } = useTranslation()
  if (isLoading) return null
  if (!hasAnyGrant(...anyOf)) {
    return (
      <div className="page">
        <EmptyState
          icon="pi pi-lock"
          title={t('minutes.forbidden.title')}
          description={t('minutes.forbidden.desc')}
        />
      </div>
    )
  }
  return <>{children}</>
}
